import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import Keycloak from "keycloak-js";
import axios from "axios";
import MenuHome from "./MenuHome";

import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./App.css";

function App() {
  const [keycloak, setKeycloak] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const kc = new Keycloak({
      url: "https://login.campusfaso.bf/auth/",
      realm: "campusFaso",
      clientId: "campus-faso",
    });

    kc.init({
      checkLoginIframe: false,
      promiseType: "native",
    })
      .then(() => {
        setKeycloak(kc);

        if (kc.authenticated) {
          setAuthenticated(true);
          setToken(kc.token);
          setUserInfo(kc.tokenParsed);
          //console.log(kc.tokenParsed)
          const roles = kc.tokenParsed.realm_access.roles
          const codeIesr = kc.tokenParsed?.code_iesr
          let admin_secure = 0; 
          let univ_secure = 0;
          const profiles = roles.map(role => {
            if(role === "campus-admin-secure") {
              admin_secure = 1
            }
            else if(role === "campus-univ-secure"){
              univ_secure = 1
            }
            return role;
          })
          localStorage.setItem('codeIesr', JSON.stringify(codeIesr))
          localStorage.setItem('admin_secure', JSON.stringify(admin_secure))
          localStorage.setItem('univ_secure', JSON.stringify(univ_secure))
          if(admin_secure || univ_secure) axios.defaults.headers.common["Authorization"] = "Bearer " + kc.token;
          else alert("L'utilisateur n'a pas le rôle adéquat !")
          

          setInterval(() => {
            kc.updateToken(60)
              .then((refreshed) => {
                if (refreshed) {
                  setToken(kc.token);
                  if(admin_secure || univ_secure) axios.defaults.headers.common["Authorization"] = "Bearer " + kc.token;
                  else alert("L'utilisateur n'a pas le rôle adéquat !")
                  console.log("Token rafraîchi :", kc.token);
                }
              })
              .catch(() => console.warn("Impossible de rafraîchir le token"));
          }, 60000);
        }
      })
      .catch((err) => console.error("Erreur Keycloak init:", err));
  }, []);

  const handleLogin = () => {
    if (keycloak) keycloak.login({ redirectUri: window.location.origin });
  };

  const handleLogout = () => {
    if (keycloak) keycloak.logout({ redirectUri: window.location.origin });
    setAuthenticated(false);
    setToken(null);
    setUserInfo(null);
    localStorage.clear();
  };

  const logo = "/campusfaso-logo.png";

  return (
    <div className="flex flex-column min-h-screen">
  
      <header className="header-container shadow-2 p-3 flex align-items-center justify-content-between flex-wrap">
        <div className="flex align-items-center gap-2">
          <img src={logo} width={100} alt="Logo CAMPUSFASO" />
        </div>

        <div className="text-center flex-1 hidden md:flex justify-content-center">
          <span className="header-title text-center">
            Authentification des diplômes des étudiants issus de la plateforme{" "}
            <strong>CAMPUSFASO</strong>
          </span>
        </div>

        <div className="flex justify-content-end">
          {!authenticated ? (
            <Button
              label="Connexion"
              icon="pi pi-sign-in"
              className="p-button-rounded p-button-outlined p-button-sm"
              onClick={handleLogin}
            />
          ) : (
            <Button
              label="Déconnexion"
              icon="pi pi-sign-out"
              className="p-button-rounded p-button-outlined p-button-sm"
              onClick={handleLogout}
            />
          )}
        </div>
      </header>

      <main
        className="flex flex-1 flex-column px-0"
        style={{
          backgroundImage: "url('/background-campus.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          minHeight: "100vh",
        }}
      >
        {!authenticated ? (
          <div
            className="flex flex-column align-items-center justify-content-center"
            style={{ flex: 1 }}
          >
            <h1>Bienvenue sur la plateforme d'Authentification</h1>
            <p>
              Ce portail permet la vérification et l’authentification des diplômes
              des étudiants issus de la plateforme CAMPUSFASO.
            </p>
            <Button
              label="Se connecter"
              icon="pi pi-user"
              className="mt-4 p-button-lg"
              onClick={handleLogin}
            />
          </div>
        ) : (
          <div className="flex flex-column" style={{ flex: 1 }}>
            <MenuHome token={token} user={userInfo} />
          </div>
        )}
      </main>

      <footer className="text-center p-3 bg-gray-200 mt-auto text-sm md:text-base">
        © {new Date().getFullYear()} CAMPUSFASO — Tous droits réservés.
      </footer>
    </div>
  );
}

export default App;
